<template>
  <v-card
    :class="cardClasses"
    style="width: fit-content"
  >
    <v-card-text :class="cardTextClasses">
      {{ mensagemReferenciaConteudoTexto }}
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/chat.scss';
</style>

<script>
import { computed } from '@vue/composition-api'

export default {
  props: {
    mensagemReferenciaConteudoTexto: {
      type: String,
      default: null,
    },
    isMensagemDoAtendente: {
      type: Boolean,
      required: true,
    },
  },

  setup(props) {
    const cardClasses = computed(() => `
        d-flex chat-content
        ${props.isMensagemDoAtendente ? 'primary white--text' : 'bg-color'}
    `)

    const cardTextClasses = computed(() => `
      px-4 py-2
      ${props.isMensagemDoAtendente ? 'white--text' : ''}
    `)

    return {
      cardClasses,
      cardTextClasses,
    }
  },
}
</script>
